<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	import { postReq } from 'src/services/http';
	//Stores
	import { home_data } from 'src/stores/account/user';
import { auth_locked_devices } from 'src/stores/device-runtime/local-auth';
import { os, app } from 'src/stores/session/native-bridge';
	import { allDiscovered, ongoingDiscovery } from 'src/stores/features/discovered';
	// import { save_home } from 'src/helpers/home_helpers';
	//Design system components
	import { Alert, Toggle, toast } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	import { init_discover_devices_android } from 'src/services/native_container_requests_android';
	import { init_discover_devices_ios } from 'src/services/native_container_requests_ios';
	import { save_home } from 'src/helpers/home_helpers';

	let checked =
		typeof $home_data?.globalLocalControl !== 'undefined'
			? $home_data?.globalLocalControl.useLocal
			: JSON.parse(localStorage.getItem('globalLocalControl'))?.useCloud || true;

	const save = async (e) => {
		checked = e.target.checked;

		save_home('globalLocalControl', {
			useLocal: checked,
		});

		home_data.set({
			...$home_data,
			globalLocalControl: {
				useLocal: checked,
			},
		});

		if (checked) {
			toast.open({
				type: 'success',
				title: $format('toast_local_control_setting', {
					default: 'local control enabled',
				}),
			});
			if (!$app) {
				return;
			}
			if ($os === 'IOS') {
				init_discover_devices_ios();
			} else {
				init_discover_devices_android();
			}
			ongoingDiscovery.set(true);
			setTimeout(() => {
				ongoingDiscovery.set(false);
			}, 20000);
		} else {
			auth_locked_devices.set([]);
			toast.open({
				type: 'success',
				title: $format('toast_local_control_setting', {
					default: 'local control disabled',
				}),
			});
			allDiscovered.set({});
		}
	};
</script>

<Alert
	class="mb-m"
	type="warning"
	isHeadingBold
	heading={capFirstChar(
		$format('alert_warning_generic_attention', {
			default: 'Attention!',
		}),
	)}
	message={capFirstChar(
		$format('alert_warning_message_local_control_setting', {
			default:
				'Disabling Local Network Control might improve the device communication and control for some Wi-Fi networks. On the other hand it is extremely unadvised to turn this off if you plan on using the devices without cloud connection.',
		}),
	)}
/>

<Alert
	class="mb-m"
	heading={capFirstChar(
		$format('alert_info_local_control_setting', {
			default:
				'When turned off the app will control the Shelly devices in your account only via the cloud.',
		}),
	)}
/>

<Toggle class="mb-s" id="toggle-local-control" bind:checked size="m" on:click={save}>
	{$format('input_local_control_setting', {
		default: 'Use Local Network Control when available.',
	})}
</Toggle>
